// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { PrimaryButton } from 'ui_kit_qmd'
import { OptionTile } from './components/option-tile/OptionTile'
import { HeaderView } from '../header-view/HeaderView'
import { useProductOrderContext } from '../../context'
import './productSelectionView.scss'
import { useCallback } from 'react'
import { useGetOrderNameFromProduct } from 'components/product-order-popup/hooks/useGetOrderNameFromProduct'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { CartItem } from 'types/products/productTypes'

interface Props {
  title: string
  onConfirmSelection: () => void
}

export const ProductSelectionView = ({ title, onConfirmSelection }: Props) => {
  const {
    selectedOption,
    category,
    product,
    isMHT,
    editCartItemId,
    // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
    setCartItems,
    // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
    orderInfo,
    // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
    isPharmacyPickup,
    isMoudHomeDelivery,
    updateCart,
  } = useProductOrderContext()
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const { getOrderNameFromProduct } = useGetOrderNameFromProduct({ isMoudHomeDelivery })

  const options = product?.Options ?? []

  const handleClick = useCallback(() => {
    updateCart()
    onConfirmSelection()
  }, [onConfirmSelection, updateCart])
  return (
    <div className='product-selection-view-container'>
      <HeaderView title={title} />

      <div className='product-selection-view-body-container'>
        {options[0]?.Price ?
          <div className='product-selection-view-text-container'>
            All prices shown do not yet reflect any visit or accounts credits, which will be applied prior to payment.
          </div>
        : null}

        {category === 'moud' ?
          <div className='product-selection-view-text-container'>Please select a medication:</div>
        : null}

        <div className='product-selection-view-doses-container'>
          {options.map((option) => (
            <OptionTile key={option.OptionId} option={option} />
          ))}
        </div>
      </div>

      <div className='product-selection-view-button-container'>
        <PrimaryButton
          useUpdatedStyle
          disabled={selectedOption === undefined}
          btnText={
            isMHT ?
              editCartItemId ?
                'Edit item'
              : 'Add to order'
            : 'Continue'
          }
          onPress={handleClick}
        />
      </div>
    </div>
  )
}
